module.exports = __webpack_public_path__ + "img/Yellow-R-3@2x.803433f2.png";